import React from "react";
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from "../../Global/Header1";
import Pageheader from "../MenCareers/PageHeader";
import Careers from "../MenCareers/Careers";
import WhyChooseSix from "../MenCareers/WhyChouseSix";
import FaqFour from "../MenCareers/FaqFour";
import CtaTwo from "../../Global/Cta";
import Footer from "../../Global/Footer1";
import GoToTop from "../../Global/GoToTop";
const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <Pageheader />
            <Careers />
            <WhyChooseSix />
            <FaqFour />
            <CtaTwo />
            <Footer />
            <GoToTop />
        </>
    )
}
export default Main;